<template>
  <CCard>
    <CCardHeader
      style="background: #1a3665; color: white"
      class="d-flex align-items-center font-weight-bold"
    >
      Master Pakta integritas
      <template v-if="role_status && role_status.status_create">
      <CButton
        color="success"        
        class="btn-md ml-auto button-md-block px-3"
        @click="createData">Tambah</CButton>
      </template>
      <template v-else>
      <CButton
        color="secondary"        
        class="btn-md ml-auto button-md-block px-3"
        disabled>Tambah</CButton>
      </template>
    </CCardHeader>
    <CCardBody>
      <CRow>
        <CCol xl="12">
          <CSelect
            label="Data Perhalaman"
            class="float-left"
            @change="changePageSize"
            :options="[10, 25, 100, 'Semua Data']"
          />
          <CInput
            label="Pencarian"
            class="float-right"
            v-model="search"
            placeholder="Cari Data .."
          />
          <br />
        </CCol>
      </CRow>
      <CRow>
        <CCol lg="12" class="table-responsive">
          <CDataTable
            style="widht: 100% !important"
            :items="items"
            :fields="fields"
            hover
            sorter
          >
            <template #no="{ index }">
              <td class="py-2">
                {{ indexed == 0 ? index + 1 : index + indexed + 1 }}
              </td>
            </template>

            <template #namaKategori="{ item }">
              <td class="py-2 text-left">
                {{ item.namaKategori ? item.namaKategori : "-" }}
              </td>
            </template>

            <template #deskripsi="{ item }">
              <td class="py-2 text-left">
                {{ item.deskripsi ? item.deskripsi : "-" }}
              </td>
            </template>
            <template #aksi="{ item, index }">
              <td class="py-2 text-center">
                <template v-if="role_status && role_status.status_update">
                <CButton v-c-tooltip="'Ubah'" color="info" square size="sm" @click="updateData(item, index)">
                  <font-awesome-icon icon="edit" />
                </CButton>&nbsp;&nbsp;
                </template>
                <template v-else>
                <CButton v-c-tooltip="'Ubah'" color="secondary" square size="sm" disabled>
                  <font-awesome-icon icon="edit" />
                </CButton>&nbsp;&nbsp;
                </template>
                <template v-if="role_status && role_status.status_delete">
                <CButton v-c-tooltip="'Hapus'" color="danger" square size="sm" @click="deleteData(item, index)">
                  <font-awesome-icon icon="trash" />
                </CButton>
                </template>
                <template v-else>
                <CButton v-c-tooltip="'Hapus'" color="secondary" square size="sm" disabled>
                  <font-awesome-icon icon="trash" />
                </CButton>
                </template>
              </td>
            </template>
          </CDataTable>

          <CPagination
            style="float: right"
            :active-page.sync="currentPage"
            :pages="pagination.totalPages"
            responsive
            @click="pageChange"
          />
        </CCol>
      </CRow>

      <!-- Modal Tambah -->
      <CModal
        title="Modal title"
        :show.sync="myModal"
        :no-close-on-backdrop="true"
        :centered="true"
      >
        <CForm v-on:submit.prevent="postData">
          <CRow>
            <CCol sm="12">
              <CInput
                class="font-weight-bold"
                label="Nama Kategori"
                v-model="formData.namaKategori"
                placeholder="Masukkan nama kategori"
                :class="{
                  'is-invalid': $v.formData.namaKategori.$error,
                }"
              />
            </CCol>

            <CCol sm="12">
              <label for="deskripsi" class="font-weight-bold">Deskripsi</label>
              <textarea name="" class="form-control" id="" cols="30" rows="4" 
                placeholder="Masukkan deskripsi"
                v-model="formData.deskripsi" 
                :class="{
                  'is-invalid': $v.formData.deskripsi.$error,
                }"></textarea>
            </CCol>
          </CRow>
        </CForm>
        <template #header>
          <h6 class="modal-title h4 font-weight-bold">{{ title }}</h6>
        </template>
        <template #footer>
          <CButton @click="myModal = false" color="danger">Tutup</CButton>
          <CButton @click="postData" type="submit" color="success"
            >Simpan</CButton
          >
        </template>
      </CModal>
      <!-- End Modal -->
    </CCardBody>
  </CCard>
</template>
<script>
import { required } from "vuelidate/lib/validators";

import PaktaIntegritasService from "@/services/datamaster/pakta-integritas.service";
import { AlertUtils } from "@/mixins/AlertUtils";

const fields = [
  { key: "no", _style: "width: 8%" },
  {
    key: "namaKategori",
    label: "Nama Kategori",
  },
  {
    key: "deskripsi",
    label: "Deskripsi",
  },
  { key: "aksi", _style: "width:15%; text-align: center" },
];

export default {
  name: "Pakta Integritas",
  mixins: [AlertUtils],
  data() {
    return {
      items: [],
      title: "",
      actionPost: "",
      formData: {
        namaKategori: "",
        deskripsi: "",
        idKategoriPaktaIntegritas: ""
      },
      pagination: {
        totalPages: 0,
      },
      currentPage: 0,
      details: [],
      fields,
      no: 1,
      search: "",
      pageSize: "",
      indexed: 0,
      status: false,
      myModal: false,
      horizontal: { label: "col-3", input: "col-9" },
      collapseDuration: 0,
      content: [],
      role_status: null
    };
  },

  validations: {
    formData: {
      namaKategori: { required },
      deskripsi: { required },
    },
  },

  watch: {
    search: function (val) {
      clearTimeout(this.timeout);
      var vm = this;
      this.timeout = setTimeout(function () {
        vm.getData("0", vm.pageSize, vm.search);
      }, 1000);
    },
    currentPage: function (val) {
      // alert(val-1);
      var page = val - 1;
      this.indexed = page * 10;
      this.getData(val - 1, this.pageSize, this.search);
    },
    myModal: function () {
      this.$v.$reset();

      document.getElementById("levelInput").classList.remove("is-valid");
    },
  },

  mounted() {
    this.getData("0", this.pageSize, this.search);
    this.roleData();
  },

  methods: {
    setNamaKategori(value) {
      this.formData.namaLevel = value;
      this.$v.formData.namaLevel.$touch();
      if (!this.$v.formData.namaLevel.$error) {
        document.getElementById("levelInput").classList.add("is-valid");
      }
    },
    roleData()
    {
      var user = JSON.parse(localStorage.getItem('user'));
      var data = user.singleData.detail_user.roles.find(el => el.url === this.$route.path );  
      this.role_status = data;
    },
    pageChange() {
      // alert('test')
      this.getData(this.currentPage);
    },
    changePageSize(e) {
      // comment console console.log(e.target.value);
      var pageSize = "";

      if (e.target.value == "Semua Data") {
        pageSize = "500";
        this.pageSize = pageSize;
      } else {
        pageSize = e.target.value;
        this.pageSize = pageSize;
      }
      this.getData("0", pageSize, this.search);
    },

    createData() {
      this.myModal = true;

      this.formData = {};

      this.actionPost = "insert";
      this.title = "Tambah";
    },

    updateData(value, index) {
      this.myModal = true;

      this.formData = value;

      this.actionPost = "update";
      this.title = "Edit";
    },

    deleteData(item, index) {
      this.formData = item;
      this.$swal
        .fire({
          title: "Peringatan!",
          text: "Apakah anda yakin ingin menghapus data ini ?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Ya",
          cancelButtonText: "Tidak",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          reverseButtons: true,
        })
        .then((result) => {
          if (result.value) {
            PaktaIntegritasService.deletePaktaIntegritas(this.formData)
              .then((response) => {
                // comment console console.log(response);
                this.alertDeleteSuccess();
                this.getData("0", this.pageSize, this.search);
                // catch kalau response error
              })
              .catch((error) => {
                this.alertError();
                // comment console console.log(error);
              });
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            this.$swal.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    },

    getData(currentPage, pageSize, filter) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel,
      });

      PaktaIntegritasService.getPaktaIntegritas(currentPage, pageSize, filter)
        .then((response) => {
          loader.hide();
          // comment console console.log(response.data.data.content);
          this.items = response.data.data.content;
          this.pagination.totalPages = response.data.data.totalPages;
          this.currentPage = response.data.data.pageable.pageNumber + 1;
          setTimeout(() => loader.hide(), 1000);
        })
        .catch((error) => {
          loader.hide();
          // comment console console.log(error);
        });
    },

    postData() {
      this.$v.$touch();
      if (this.actionPost == "insert") {
        if (this.$v.$invalid) {
          return;
        } else {
          this.insertData(this.formData);
        }
      } else if (this.actionPost == "update") {
        if (this.$v.$invalid) {
          return;
        } else {
          this.putData();
        }
      }
    },
    insertData(formData) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel,
      });
      // comment console console.log(formData);
      // comment console console.log("posat");

      var vm = this;

      PaktaIntegritasService.postPaktaIntegritas(formData)
        .then((response) => {
          vm.myModal = false;

          vm.alertSuccess();

          vm.getData("0", this.pageSize, this.search);
          loader.hide();
        })
        .catch((error) => {
          loader.hide();
          // comment console console.log(error);
          vm.alertError(error.response.data.message);
        });
    },

    putData() {
      // comment console console.log("put");
      // comment console console.log(this.formData);

      var vm = this;
      PaktaIntegritasService.putPaktaIntegritas(this.formData)
        .then((response) => {
          vm.myModal = false;
          vm.getData("0", this.pageSize, this.search);
          vm.alertEditSuccess();
        })
        .catch((error) => {
          // comment console console.log(error);

          vm.alertError(error.response.data.message);
        });
    },
  },
};
</script>